var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartlyPatern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 768,
    viewBox: "0 0 768 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1408_3516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 64C64 28.6536 35.347 0 0 0V0.0695613C0.0388867 35.384 28.6769 64 64 64Z",
    fill: "#7D14E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 320C384 284.654 355.347 256 320 256V256.07C320.039 291.384 348.677 320 384 320Z",
    fill: "#FFEB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 576C483.346 576 512 547.347 512 512L511.93 512C476.616 512.039 448 540.677 448 576Z",
    fill: "#FD5C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 192C675.346 192 704 163.347 704 128L703.93 128C668.616 128.039 640 156.677 640 192Z",
    fill: "#4F3DFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 -2.79753e-06C220.654 -1.25249e-06 192 28.653 192 64L192.07 64C227.384 63.9611 256 35.3231 256 -2.79753e-06Z",
    fill: "#9CD6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 320C768 284.654 739.347 256 704 256V256.07C704.039 291.384 732.677 320 768 320Z",
    fill: "#9CD6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 6.68917e-06C64 35.3459 92.654 64 128.001 64C163.347 64 192 35.3458 192 -4.50094e-06L64 6.68917e-06V6.68917e-06Z",
    stroke: "#FFEB00",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 448C419.346 448 448 419.346 448 383.999C448 348.653 419.346 320 384 320L384 448V448Z",
    stroke: "#FF6432",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 192C448 156.654 419.346 128 383.999 128C348.653 128 320 156.654 320 192H448Z",
    fill: "#4F3DFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 320C732.654 320 704 348.654 704 384.001C704 419.347 732.654 448 768 448L768 320V320Z",
    stroke: "#FFEB00",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704 704C704 668.654 675.346 640 639.999 640C604.653 640 576 668.654 576 704H704V704Z",
    stroke: "#9CD6FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.32245e-05 640C35.3459 640 64 611.346 64 575.999C64 540.653 35.3458 512 -7.62939e-06 512L-1.32245e-05 640Z",
    fill: "#9CD6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.001 64L320.001 63.9977L320.001 64L384 64L384 63.9237C383.958 28.6132 355.323 0.00114388 320.003 4.83174e-06L320.001 4.83184e-06L320.001 0.00223262L320.001 4.83184e-06L256 7.62939e-06C256 35.3468 284.654 64 320.001 64Z",
    fill: "#7D14E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 447.999L639.998 447.999L640 447.999L640 384L639.924 384C604.613 384.042 576.001 412.677 576 447.997L576 447.999L576.002 447.999L576 447.999L576 512C611.347 512 640 483.346 640 447.999Z",
    fill: "#4F3DFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0006 384L128 384L128 383.924C127.958 348.613 99.3233 320.001 64.0029 320L64.0006 320L-2.79753e-06 320C-1.25247e-06 355.347 28.6539 384 64.0006 384Z",
    fill: "#9CD6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 127.999L63.9977 127.999L64 127.999ZM64 127.999L64 64L63.9237 64C28.6132 64.0422 0.00113814 92.6767 8.94833e-07 127.997L8.95032e-07 127.999L0.00222811 127.999L8.95032e-07 127.999L6.49014e-06 192C35.3468 192 64 163.346 64 127.999Z",
    stroke: "#4F3DFA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 160C128 142.327 113.673 128 96 128C113.673 128 128 113.673 128 96C128 113.673 142.327 128 160.001 128C142.327 128 128 142.327 128 160Z",
    fill: "#FFEB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608 320C625.673 320 640 305.673 640 288C640 305.673 654.327 320 672 320C654.327 320 640 334.327 640 352.001C640 334.327 625.673 320 608 320Z",
    fill: "#FFEB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 256C192 220.653 163.346 191.999 128 191.999C163.346 191.999 192 163.346 192 128C192 163.346 220.654 191.999 256 191.999C220.654 191.999 192 220.653 192 256Z",
    fill: "#FFEB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 384C547.347 384 576.001 355.346 576.001 320C576.001 355.346 604.654 384 640 384C604.654 384 576.001 412.654 576.001 448C576.001 412.654 547.347 384 512 384Z",
    fill: "#FFEB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 192H64V255.999C64 291.345 92.6536 320 128 320H192V255.999C192 220.653 163.346 192 128 192Z",
    fill: "#7D14E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 192C291.346 192 320 163.346 320 128C320 92.6538 291.346 64 256 64C220.654 64 192 92.6538 192 128C192 163.346 220.654 192 256 192Z",
    stroke: "#4F3DFA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 192L1.11901e-05 256L64 256C64 220.654 35.3458 192 0 192Z",
    fill: "#FF6432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 384L320 320L256 320C256 355.346 284.654 384 320 384V384Z",
    stroke: "#7D14E6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 512L448 512L448 448C412.654 448 384 476.654 384 512V512Z",
    stroke: "#4F3DFA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 256L384 256L384 192C348.654 192 320 220.654 320 256V256Z",
    stroke: "#9CD6FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703 512L767 512L767 448C731.654 448 703 476.654 703 512V512Z",
    stroke: "#9CD6FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575 512L511 512L511 576C546.346 576 575 547.346 575 512Z",
    fill: "#9CD6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639 128L639 64L575 64C575 99.3464 603.654 128 639 128V128Z",
    stroke: "#9CD6FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 384L384 384L384 320C348.654 320 320 348.654 320 384Z",
    fill: "#FF6432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 512L384 576L448 576C448 540.654 419.346 512 384 512Z",
    fill: "#4F3DFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 384L192 384L192 320C156.654 320 128 348.654 128 384Z",
    fill: "#241F82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 256C28.6536 256 -1.54506e-06 284.653 0 320L0.0695613 320C35.384 319.961 64 291.323 64 256Z",
    stroke: "#FFEB00",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 320L320 320L320 256.001C320 220.655 291.346 192 256 192C220.654 192 192 220.655 192 256.001C192 291.347 220.654 320 256 320Z",
    fill: "#4F3DFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 128L384 128L384 64C348.654 64 320 92.6542 320 128Z",
    fill: "#FF6432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 576L640 640L704 640C704 604.654 675.346 576 640 576Z",
    fill: "#FFEB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 0L704 -2.79753e-06L704 64C739.346 64 768 35.3458 768 0Z",
    fill: "#FFEB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704 768L768 768L768 704C732.654 704 704 732.654 704 768Z",
    fill: "#FFEB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 704C320 739.346 348.653 768 384 768L384 767.93C383.961 732.616 355.323 704 320 704Z",
    fill: "#4F3DFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 768C163.346 768 192 739.347 192 704L191.93 704C156.616 704.039 128 732.677 128 768Z",
    stroke: "#4F3DFA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 768C320 732.654 291.346 704 255.999 704C220.653 704 192 732.654 192 768L320 768Z",
    fill: "#FFEB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9994 704L63.9994 704.002L63.9994 704L0 704L1.00032e-08 704.076C0.0421952 739.387 28.6767 767.999 63.9972 768L63.9994 768L63.9994 767.998L63.9994 768L128 768C128 732.653 99.3461 704 63.9994 704Z",
    fill: "#7D14E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.999 384L256 384L256 384.076C256.042 419.387 284.677 447.999 319.997 448L319.999 448L384 448C384 412.653 355.346 384 319.999 384Z",
    fill: "#9CD6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 640.001L64.0023 640.001L64 640.001L64 704L64.0763 704C99.3869 703.958 127.999 675.323 128 640.003L128 640.001L127.998 640.001L128 640.001L128 576C92.6532 576 64 604.654 64 640.001Z",
    fill: "#FF6432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 512L192 512L192 576C227.346 576 256 547.346 256 512Z",
    fill: "#4F3DFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704 256L768 256L768 192C732.654 192 704 220.654 704 256Z",
    fill: "#FF6432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 384L3.8147e-06 384L1.22073e-05 448C35.3464 448 64 419.346 64 384Z",
    fill: "#4F3DFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 576C192 540.654 163.347 512 128 512V512.07C128.039 547.384 156.677 576 192 576Z",
    fill: "#241F82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 640L3.8147e-06 640L1.22073e-05 704C35.3464 704 64 675.346 64 640Z",
    fill: "#4F3DFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 704L768 640L704 640C704 675.346 732.654 704 768 704Z",
    fill: "#4F3DFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 384C64 419.346 92.6531 448 128 448L128 447.93C127.961 412.616 99.3231 384 64 384Z",
    stroke: "#9CD6FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 608C320 625.673 334.327 640 352 640C334.327 640 320 654.327 320 672C320 654.327 305.673 640 287.999 640C305.673 640 320 625.673 320 608Z",
    fill: "#FFEB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 512C256 547.347 284.654 576.001 320 576.001C284.654 576.001 256 604.654 256 640C256 604.654 227.346 576.001 192 576.001C227.346 576.001 256 547.347 256 512Z",
    fill: "#FFEB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 576L384 576L384 512.001C384 476.655 355.346 448 320 448L256 448L256 512.001C256 547.347 284.654 576 320 576Z",
    fill: "#7D14E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 576C156.654 576 128 604.654 128 640C128 675.346 156.654 704 192 704C227.346 704 256 675.346 256 640C256 604.654 227.346 576 192 576Z",
    fill: "#9CD6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.999 576L447.999 576.002L447.999 576ZM447.999 576L384 576L384 576.076C384.042 611.387 412.677 639.999 447.997 640L447.999 640L447.999 639.998L447.999 640L512 640C512 604.653 483.346 576 447.999 576Z",
    stroke: "#4F3DFA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9994 448L63.9994 448.002L63.9994 448L0 448L-3.33441e-09 448.076C0.042189 483.387 28.6767 511.999 63.9971 512L63.9994 512L63.9994 511.998L63.9994 512L128 512C128 476.653 99.3461 448 63.9994 448Z",
    fill: "#FFEB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.999 704L575.999 704.002L575.999 704L512 704L512 704.076C512.042 739.387 540.677 767.999 575.997 768L575.999 768L575.999 767.998L575.999 768L640 768C640 732.653 611.346 704 575.999 704Z",
    fill: "#4F3DFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544 608C561.673 608 576 593.673 576 576C576 593.673 590.327 608 608 608C590.327 608 576 622.327 576 640.001C576 622.327 561.673 608 544 608Z",
    fill: "#FFEB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 576C640 540.654 611.347 512 576 512V512.07C576.039 547.384 604.677 576 640 576Z",
    stroke: "#FF6432",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 704V768H512C512 732.654 483.346 704 448 704V704Z",
    stroke: "#4F3DFA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 704L448 640L384 640C384 675.346 412.654 704 448 704Z",
    fill: "#241F82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 640V704H576C576 668.654 547.346 640 512 640Z",
    fill: "#FD5C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 384L448 384L448 256L512 256C547.346 256 576 284.655 576 320.001C576 355.347 547.346 384 512 384Z",
    fill: "#7D14E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 512C547.346 512 576 483.346 576 448C576 412.654 547.346 384 512 384C476.654 384 448 412.654 448 448C448 483.346 476.654 512 512 512Z",
    stroke: "#9CD6FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 256C576 220.654 547.347 192 512 192V192.07C512.039 227.384 540.677 256 576 256Z",
    fill: "#7D14E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 192C640 156.654 611.346 128 575.999 128C540.653 128 512 156.654 512 192H640Z",
    fill: "#FD5C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 256.001L384 320H384.076C419.387 319.958 447.999 291.323 448 256.003V256.001L448 192C412.653 192 384 220.654 384 256.001Z",
    fill: "#241F82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.999 192L639.999 192.002M639.999 192L576 192L576 192.076C576.042 227.387 604.677 255.999 639.997 256L639.999 256M639.999 192C675.346 192 704 220.653 704 256L639.999 256M639.999 256L639.999 255.998",
    stroke: "#4F3DFA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.999 512L703.999 512.002M703.999 512L640 512L640 512.076C640.042 547.387 668.677 575.999 703.997 576L703.999 576M703.999 512C739.346 512 768 540.653 768 576L703.999 576M703.999 576L703.999 575.998",
    stroke: "#FF6432",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.999 512L640 512L640 512.076C640.042 547.387 668.677 575.999 703.997 576L703.999 576L768 576C768 540.653 739.346 512 703.999 512Z",
    fill: "#FF6432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 128C476.654 128 448 156.653 448 192L448.07 192C483.384 191.961 512 163.323 512 128Z",
    fill: "#FFEB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 -2.79753e-06C604.654 -1.25249e-06 576 28.653 576 64L576.07 64C611.384 63.9611 640 35.3231 640 -2.79753e-06Z",
    fill: "#FD5C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 256C512 220.654 483.347 192 448 192V192.07C448.039 227.384 476.677 256 512 256Z",
    stroke: "#FFEB00",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 64L384 128L447.999 128C483.345 128 512 99.3464 512 64C512 28.6536 483.345 3.28687e-06 447.999 4.83189e-06C412.653 6.37692e-06 384 28.6536 384 64Z",
    fill: "#241F82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511 64.0006H511.002H511ZM511 64.0006L511 128H511.076C546.387 127.958 574.999 99.3233 575 64.0029V64.0006H574.998H575L575 0C539.653 0 511 28.6539 511 64.0006Z",
    stroke: "#7D14E6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704 512C704 476.654 675.347 448 640 448V448.07C640.039 483.384 668.677 512 704 512Z",
    fill: "#241F82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704 448C704 412.654 675.347 384 640 384V384.07C640.039 419.384 668.677 448 704 448Z",
    fill: "#7D14E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 576C732.654 576 704 604.653 704 640L704.07 640C739.384 639.961 768 611.323 768 576Z",
    fill: "#4F3DFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.999 64L639 64L639 64.0763C639.042 99.3868 667.677 127.999 702.997 128L702.999 128L767 128C767 92.6532 738.346 64 702.999 64Z",
    fill: "#9CD6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 448L128 512L191.999 512C227.345 512 256 483.346 256 448C256 412.654 227.345 384 191.999 384C156.653 384 128 412.654 128 448Z",
    stroke: "#FF6432",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 576L128 512L64 512C64 547.346 92.6542 576 128 576V576Z",
    stroke: "#FF6432",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 704C512 668.654 483.347 640 448 640V640.07C448.039 675.384 476.677 704 512 704Z",
    stroke: "#FFEB00",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1408_3516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 768,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartlyPatern);
export default __webpack_public_path__ + "static/media/smartly-patern.9c00f783a4f7357c2b5e1bac1ea57ca1.svg";
export { ForwardRef as ReactComponent };